import { CheckCircle2, MapPin, Phone, UserRound } from 'lucide-react';
import { Button, Card } from '../../ui';

/**
 * WHAT A NEWLY REGISTERED FARMER SEES, whichever door they came through.
 *
 * The one thing this screen owes them is who will get in touch. Where their area has a rep it names
 * them and offers the call; where it has none it says the team will be in touch and gives the company
 * number — never a bare "done", and never a named person we have not actually assigned.
 */
export function FarmerWelcomeCard({
  done, support, onContinue, continueLabel = 'Continue',
}: {
  done: { fullName?: string; place?: string; representative?: { name?: string; role?: string; mobile?: string | null } | null };
  support?: { phone?: string | null } | null;
  onContinue: () => void;
  continueLabel?: string;
}) {
  return (
    <Card>
      <div className="flex flex-col items-center text-center">
        <CheckCircle2 size={44} className="text-brand-600" aria-hidden />
        <h1 className="mt-3 type-section-title text-content">Welcome, {done.fullName}</h1>
        <p className="mt-1 type-body text-muted"><MapPin size={14} className="mr-1 inline" aria-hidden />{done.place}</p>
      </div>
      <div className="mt-6 rounded-lg border border-line bg-surface-2 p-4">
        {done.representative ? (
          <>
            <div className="type-overline text-muted">Your Green Bay representative</div>
            <div className="mt-1 flex items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="type-body-strong text-content"><UserRound size={15} className="mr-1 inline" aria-hidden />{done.representative.name}</div>
                <div className="type-caption text-muted">{done.representative.role} · will call you within 2 working days</div>
              </div>
              {done.representative.mobile && (
                <a href={`tel:${done.representative.mobile}`} className="inline-flex shrink-0 items-center gap-1 rounded-md bg-brand-500 px-3 py-2 type-label-strong text-white">
                  <Phone size={15} aria-hidden /> Call
                </a>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="type-body-strong text-content">Our team will contact you soon</div>
            <div className="mt-1 type-caption text-muted">We will connect you with the right person for your area.</div>
            {support?.phone && (
              <a href={`tel:${support.phone.replace(/\s/g, '')}`} className="mt-3 inline-flex items-center gap-1 type-label-strong text-brand-700">
                <Phone size={15} aria-hidden /> {support.phone}
              </a>
            )}
          </>
        )}
      </div>
      <Button variant="primary" block className="mt-6" onClick={onContinue}>{continueLabel}</Button>
    </Card>
  );
}
